export default __webpack_public_path__ + "static/imagecloud-0461212e83484d32c1666e5b95f89d84.png";